export default import.meta.ROLLDOWN_FILE_URL_RJvXuaUV6a0JYddfOv$nwA